// store/activePetSlice.js
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const initialPet = cookies.get("activepet") || null;

const activePetSlice = createSlice({
  name: "activePet",
  initialState: initialPet,
  reducers: {
    setActivePet: (state, action) => {
      const newPet = action.payload;
      cookies.set("activepet", newPet, { path: "/" }); // keep cookie in sync
      return newPet;
    },
    clearActivePet: () => {
      cookies.remove("activepet", { path: "/" });
      return null;
    },
  },
});

export const { setActivePet, clearActivePet } = activePetSlice.actions;
export default activePetSlice.reducer;
